import { supabase } from "@/integrations/supabase/client";

export interface DocumentExportData {
  id: string;
  type: string;
  title: string;
  content: string;
  jobTitle?: string;
  company?: string;
}

export interface ExportOptions {
  templateName?: 'professional' | 'modern' | 'classic';
}

export class DocmosisService {
  static async exportToWord(
    documents: DocumentExportData[],
    options: ExportOptions = {}
  ): Promise<Blob> {
    try {
      console.log('Exporting documents to Word via Docmosis:', {
        documentCount: documents.length,
        templateName: options.templateName || 'professional'
      });

      const { data, error } = await supabase.functions.invoke('export-to-word', {
        body: {
          documents,
          templateName: options.templateName || 'professional'
        }
      });

      if (error) {
        console.error('Error calling export-to-word function:', error);
        throw new Error(`Export failed: ${error.message}`);
      }

      // The response should be a blob (binary data)
      if (data instanceof Blob) {
        return data;
      }

      // If it's not a blob, try to convert it
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      });

      return blob;

    } catch (error) {
      console.error('Error in DocmosisService.exportToWord:', error);
      throw new Error(
        error instanceof Error 
          ? error.message 
          : 'Failed to export documents to Word'
      );
    }
  }

  static downloadBlob(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}